export enum LoanGoalName {
  consolidate_my_debt = 'Consolidate my debt',
  get_out_of_debt_faster = 'Get out of debt faster',
  lower_my_payment = 'Lower my payment',
  get_a_lower_interest_rate = 'Get a lower interest rate',
  all_of_the_above = 'All of the above',
}
